'use client'

import { useEffect } from 'react'
import { log } from '@dustin-web/microsite-config/src/logger'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error('Client side error caught by ErrorBoundary', { error })

    log.error({ err: error }, '[APP CLIENT]: Client side error caught by ErrorBoundary')
  }, [error])

  return (
    <div className="container u-pt-md-48">
      <h2>Something went wrong!</h2>
      <pre style={{ color: 'red' }}>{error?.message}</pre>
      <p>
        Please refresh the page and try again. If the issue persists, contact customer support for
        assistance.
      </p>
      <button
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }>
        Reload Page
      </button>
    </div>
  )
}
